import { Accordion, Badge, Button, Form } from 'react-bootstrap';
import styled from "styled-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const CustomBadge = styled(Badge)`
    background-color: ${props => props.colors.primary} !important;
    color: ${props => props.colors.onPrimary} !important;
`

export const CustomButton = styled(Button)`
    background-color: ${props => props.colors.primary} !important;
    border-color: ${props => props.colors.primary} !important;
    color: ${props => props.colors.onPrimary} !important;
    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.25rem ${props => props.colors.primary}40 !important;
    }
`

export const CustomBlockButton = styled(CustomButton)`
    min-width: 100%;
`

export const CustomFileControlButton = styled(Button)`
    background-color: #E9ECEF !important;
    border-color: lightgrey !important;
    color: black !important;
    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.25rem ${props => props.colors.primary}40 !important;
        border-color: ${props => props.colors.primary}40 !important;
    }
    &:hover {
        background-color: rgba(0,0,0,.12) !important;
    }
`

export const CustomLink = styled(Button).attrs({
    'variant': 'link'
})`
    color: ${props => props.colors.primary} !important;
    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.25rem ${props => props.colors.primary}40 !important;
    }
`

export const TileButton = styled(Button)`
    background-color: ${props => props.colors.onPrimary} !important;
    border-color: rgba(0,0,0,.125) !important;
    color: ${props => props.colors.primary} !important;
    border-radius: 10px !important;
    font-weight: 700;
    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.25rem ${props => props.colors.primary}40 !important;
    }
    &:hover {
        background-color: rgba(0,0,0,.03) !important;
    }
    padding: 0px;
    box-shadow: 1px 1px 4px 0.05rem #40404040 !important;
    text-align: left;
`

export const CustomFormControl = styled(Form.Control)`
    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.25rem ${props => props.colors.primary}40 !important;
        border-color: ${props => props.colors.primary}40 !important;
    }
`

export const CustomFileControlText = styled(CustomFormControl)`
    background-color: white !important;
    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.25rem ${props => props.colors.primary}40 !important;
        border-color: ${props => props.colors.primary}40 !important;
    }
`

export const Textarea = styled.textarea`
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    appearance: none;
    border-radius: 0.375rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
`;

export const CustomFormSelect = styled(Form.Select)`
    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.25rem ${props => props.colors.primary}40 !important;
        border-color: ${props => props.colors.primary}40 !important;
    }
`

export const JobTitle = styled.div`
    padding-top: 1px;
    padding-bottom: 1px;
    display: flex;
    justify-content: center;
    font-size: 28px;
    font-weight: 600;
`

export const ListJobTitle = styled(Form.Text)`
    color: ${props => props.colors.primary};
    font-size: 18px;
    font-weight: 500;
`

export const JobSubtitle = styled.div`
    color: black;
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 6px;
    padding-bottom: 10px;
`

export const DetailsJobSubtitle = styled.div`
    color: black;
    display: flex;
    justify-content: center;
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 6px;
`

export const GroupTitle = styled.div`
    font-size: 20px;
    padding: 30px 7px 18px 0px;
`

export const ColumnTitle = styled.div`
    font-size: 14px;
    color: black;
    font-weight: 600;
`

export const ListIcon = styled(FontAwesomeIcon)`
    padding-top: 5px;
    color: black;
    margin-right: 5px !important;
`

export const CustomAccordionButton = styled(Accordion.Button)`
    background-color: white;
    color: ${props => props.colors.primary};
    &:not(.collapsed) {
        background-color: white;
        color: ${props => props.colors.primary};
        
    }
    &:not(.collapsed)::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e");
    }
    &:focus {
        box-shadow: 0 0 0 0.25rem ${props => props.colors.primary}40 !important;
        border-color: ${props => props.colors.primary}40 !important;;
    }
`

export const CustomSelect = styled(Form.Select)`
    border-radius: 10px;
    margin-bottom: 10px;
`